import React from 'react';
import { BounceLoader } from 'react-spinners';

const BusyLoaderOverlay = ({ show }) => {
    if (!show) return null;

    return (
        <div className="busy-loader-overlay">
            <BounceLoader
                size={60}
                color="#5f788a"
                loading={true}
            />
        </div>
    );
};

export default BusyLoaderOverlay;
